import * as React from 'react';
import './WYSIWYGEditor.scss';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import {
  Bold,
  Italic,
  Underline as UnderlineIcon,
  Link as LinkIcon,
  OrderedList,
  UnonorderedList
} from '../Icon/icon';
import { Dropbox } from '../Dropbox/dropbox';
import { Buttons, Primary, Secondary } from 'rcd-cpp-ui/ui/button';
import { ROWYSIWYGEditor } from './ROWYSIWYGEditor';
import { RWWYSIWYGEditor } from './RWWYSIWYGEditor';

interface TipTapProps {
  content: string;
  disabled: boolean;
  readonly?: boolean;
  onChange?: any;
  isFullscreen?: boolean;
  onClickLink?: string;
}

enum SelectionType {
  NULL = 'NULL',
  LINK = 'LINK'
}

const MenuButton = ({ children, onClick, disabled, className }) => {
  let updatedClassName = 'button';
  if (className) {
    updatedClassName = updatedClassName + ' ' + className;
  }
  if (disabled) {
    updatedClassName = updatedClassName + ' disabled';
  }
  return (
    <div onClick={onClick} className={updatedClassName}>
      {children}
    </div>
  );
};
const MenuBar = ({ editor, addLink }) => {
  if (!editor) {
    return null;
  }
  return (
    <div className="button-bar">
      <MenuButton
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={editor.isActive('bold') ? 'is-active' : ''}
      >
        <Bold />
      </MenuButton>
      <MenuButton
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={editor.isActive('italic') ? 'is-active' : ''}
      >
        <Italic />
      </MenuButton>
      <MenuButton
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={!editor.can().chain().focus().toggleUnderline().run()}
        className={editor.isActive('underline') ? 'is-active' : ''}
      >
        <UnderlineIcon />
      </MenuButton>
      <MenuButton
        onClick={addLink}
        className={editor.isActive('link') ? 'is-active' : ''}
        disabled={false}
      >
        <LinkIcon />
      </MenuButton>
      <MenuButton
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive('bulletList') ? 'is-active' : ''}
        disabled={false}
      >
        <UnonorderedList />
      </MenuButton>
      <MenuButton
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={editor.isActive('orderedList') ? 'is-active' : ''}
        disabled={false}
      >
        <OrderedList />
      </MenuButton>
    </div>
  );
};

const baseExtensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false
    }
  }),
  Underline.configure({})
];

const readOnlyExtensions = [
  ...baseExtensions,
  Link.configure({
    openOnClick: true,
    HTMLAttributes: {
      rel: null,
      target: '_blank'
    }
  })
];

const editModeExtensions = [
  ...baseExtensions,
  Link.configure({
    openOnClick: false,
    HTMLAttributes: {
      rel: null,
      target: '_blank'
    }
  })
];

export const WYSIWYGEditor = (props: TipTapProps) => {
  return (
    <>
      {props?.readonly && <ROWYSIWYGEditor {...props} />}
      {!props?.readonly && <RWWYSIWYGEditor {...props} />}
    </>
  );
};
